import { render, staticRenderFns } from "./BackgroundAudio.vue?vue&type=template&id=0fb1e8c6&scoped=true&"
import script from "./BackgroundAudio.vue?vue&type=script&lang=js&"
export * from "./BackgroundAudio.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundAudio.vue?vue&type=style&index=0&id=0fb1e8c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb1e8c6",
  null
  
)

export default component.exports